import { Grid } from "@material-ui/core";
import React, { useState } from "react";
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Divider,
    Button,
    Tab,
    Tabs,
  } from "@mui/material";
import RealTimeChartTabs from "./tab-charts";
import StoredChartTab from "./stored-chart-tab";


const ChartCategory = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={value} 
          onChange={handleChange} 
          sx={{ 
            '& .MuiTab-root': { px: 2 }, 
            '& .Mui-selected': { backgroundColor: 'lightgreen', color: 'black' }, 
            '& .MuiTabs-indicator': { backgroundColor: 'darkgreen' } 
          }}
        >
          <Tab label="Stored Data Charts" />
          <Tab label="Real Time Charts" />
        </Tabs>
      </Box>
      {value === 0 && (
        <Grid>
          <StoredChartTab/>
        </Grid>
      )}
      {value === 1 && (
          <Grid>
          <RealTimeChartTabs/>
        </Grid>
      )}
    </div>
  );
};

export default ChartCategory;
